import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable'
import { Router, ActivatedRoute } from '@angular/router';
import CryptoJS from 'crypto-js';
import { QuizService } from '../../Service/Quizservice';
import { StudentresponsePage } from "../pages/Student/Studentresponse.page";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
    selector: "Studentreport-page",
    templateUrl: "./Studentreport.page.html", styleUrls: ["../app.component.css"]
})
export class StudentreportPage implements OnInit {
    quizid;
    studentdata;
    dialogRef;
    quiztitle;
    quizdesc;
  teachername;
  
    constructor(private router: Router, private QuizService: QuizService, private route: ActivatedRoute, public dialog: MatDialog) {
       

    }
    
       
      
    ngOnInit() {
        this.teachername = sessionStorage.getItem('teachername');
        this.route.queryParams.subscribe(params => {
            this.quizid = CryptoJS.AES.decrypt((params["qid"]).trim(), 'q').toString(CryptoJS.enc.Utf8);
        });
        if(!this.studentdata)
        {
            this.studentdata=JSON.parse(localStorage.getItem('studentdata'));
            //this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));
        }
       
        var jsonobj = [
            {
                "Quizid": this.quizid,
            }];
      this.QuizService.getsubmittedstudentbyid(JSON.stringify(jsonobj))
        .subscribe(data => {
          this.studentdata = JSON.parse(JSON.stringify(data));
          console.log('Received data:', data);
          localStorage.setItem('studentdata',JSON.stringify(this.studentdata));
          //sessionStorage.setItem('studentdata', JSON.stringify(this.studentdata));
        });
      
        this.quiztitle=JSON.parse(sessionStorage.getItem('ReviewOrgJson'))["pages"][0]['title'].trim();
        this.quizdesc=JSON.parse(sessionStorage.getItem('ReviewOrgJson'))["pages"][0]['description'].trim();
        document.getElementById("btnGroupDrop1").innerText = this.teachername;
    }
    review(obj,studentname) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.width = '90%';
        dialogConfig.height = '80%';
        this.dialogRef = this.dialog.open(StudentresponsePage, dialogConfig);
        sessionStorage.setItem('ReviewOrgJson1', JSON.stringify(JSON.parse(obj)));
        sessionStorage.setItem('stdnmm',studentname);
    }
    @ViewChild('reportContent') reportContent: ElementRef;
  downloadExcel() {
    document.getElementById('stdres').hidden = true;
    document.getElementById('stdres1').hidden = true;

    const filename = JSON.parse(sessionStorage.getItem('ReviewOrgJson'))['pages'][0]['title'].trim();
    const QuizDescription = JSON.parse(sessionStorage.getItem('ReviewOrgJson'))['pages'][0]['description'].trim();

    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Prepare worksheet data
    const table = document.getElementById('my-table');
    const rows = table.querySelectorAll('tr');
    rows.forEach((row) => {
      const rowData = [];
      const cells = row.querySelectorAll('td');
      cells.forEach((cell, index) => {
        // Check if the current cell belongs to the column you want to hide (e.g., column index 2)
        if (index !== 5) {
          rowData.push(cell.innerText.trim());
        }
      });
      worksheetData.push(rowData);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

    // Add extra worksheet if needed
    // const extraWorksheet = XLSX.utils.aoa_to_sheet(extraWorksheetData);
    // XLSX.utils.book_append_sheet(workbook, extraWorksheet, 'Extra Sheet');

    // Hide the column in the worksheet
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(blob, filename + '.xlsx');

    document.getElementById('stdres').hidden = false;
    document.getElementById('stdres1').hidden = false;
  }
    downloadPdf() {
        document.getElementById("stdres").hidden = true;
        document.getElementById("stdres1").hidden = true;
        var filename = JSON.parse(sessionStorage.getItem('ReviewOrgJson'))["pages"][0]['title'].trim();
        var QuizDescription = JSON.parse(sessionStorage.getItem('ReviewOrgJson'))["pages"][0]['description'].trim();
        const doc = new jsPDF();
        doc.setFontSize(10);
        const specialElementHandlers = {
            '#editor': function (element, renderer) {
                return true;
            }
        };
        var res = doc.autoTableHtmlToJson(document.getElementById("my-table"));
        var header = function (data) {
            const img=new Image();
            img.src='assets/Quiz-logo.png'
            doc.addImage(img, 'png', data.settings.margin.left, 12, 30, 10);
           doc.setFontSize(10);
            doc.setTextColor(40);
            doc.setFontStyle('normal');
           doc.text("Report", 89, 20);
           doc.text(" Copyright © 2022 ExcelSoft Technologies Pvt.Ltd. All rights reserved",data.settings.margin.left+50, data.settings.margin.bottom+273);
           doc.text("Quiz Title:" + filename + "\nQuiz Description:" + QuizDescription, 15, 35);
           //const ftr=new Image();
        //     ftr.src='assets/nt_cmyk_white.png'
        // doc.addImage(img, 'png', 25, data.settings.margin.bottom+268);
        };

        var options = {
            beforePageContent: header,
            margin: {
                top: 50
            },

            startY: doc.autoTableEndPosY() + 45
        };

        const content = this.reportContent.nativeElement;

        doc.autoTable(res.columns, res.data, options);

        doc.save(filename + '.pdf');
        document.getElementById("stdres").hidden = false;
        document.getElementById("stdres1").hidden = false;
    }
}
